import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';



function ihs(f)
{
	return (window.innerHeight * f) + "px";
}


function VideoMob(p)
{

		/* <BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" />*/
	return (<div style={{color: "#000000", fontSize: "100%", textAlign: "center"}}>
		<div className="keskitettymob">
		<h1>{window.VIDEOTEKSTIT.ekaosio}</h1>
		</div>
		<div key="gapihmomia" className="otsikkogap"></div>
		<div className="keskitettymob">
		{window.VIDEOTEKSTIT.ekaosioekar}
		</div>
		<div key="gapihmomib" className="paragap"></div>
		<div className="keskitettymob">
		{window.VIDEOTEKSTIT.ekaosiotokar}
		</div>
		<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
		<div key="gapihmomic" className="osiogap"></div>
		<BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"  width="40vh" height="100vh" />
		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div className="keskitettyjohmob">
				<h3>{window.VIDEOTEKSTIT.tokaosioekar}</h3>
				</div>
			</div>
		</div>
		<div>
			<div style={{position: "absolute", clipPath: "polygon(16% 7%, 16% 100%, 92% 100%, 92% 7%)" }}>
				{p.strvideo}
			</div>
			<div style={{position: "absolute"}}>
				<img height="500vh" src={window.VIDEOTEKSTIT.kolmasosiokuva} />
			</div>
		</div>
		<div key="gapihmomidsa" className="osiogap"></div>
		<div key="gapihmomidsb" className="osiogap"></div>
		<div key="gapihmomidsc" className="osiogap"></div>
		<div key="gapihmomidsd" className="osiogap"></div>
		<div key="gapihmomidsf" className="osiogap"></div>
		<div key="gapihmomidsg" className="osiogap"></div>
		<div key="gapihmomidsh" className="osiogap"></div>
		<div key="gapihmomidsi" className="osiogap"></div>
		<div key="gapihmomidsj" className="osiogap"></div>
		<div key="gapihmomidsk" className="osiogap"></div>
		<div key="gapihmomidsl" className="osiogap"></div>
		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div className="keskitettymob">{window.VIDEOTEKSTIT.kolmasosioekar}</div>
				<div key="gapihmomie" className="osiogap"></div>
				<div className="keskitettymob"><h3>{window.VIDEOTEKSTIT.kolmasosiotokar}</h3></div>
			</div>
		</div>
		<div key="gapihmomifb" className="osiogap"></div>
		<div key="gapihmomifcb" className="osiogap"></div>


		<div>
			<img height={ihs(0.25)} src={window.VIDEOTEKSTIT.neljasosiokuva} />
		</div>
		<div></div>
		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div className="keskitettymob">
				<h3>{window.VIDEOTEKSTIT.neljasosio}</h3>
				</div>
				<div key="gapihmomig" className="osiogap"></div>

				<div className="keskitettymob">{window.VIDEOTEKSTIT.neljasosioekar}</div>
			</div>
		</div>
		<div key="gapihmomih" className="osiogap"></div>
		<div className="keskitettymob"><h2>{window.VIDEOTEKSTIT.viidesosio}</h2></div>
		<div key="gapihmomii" className="otsikkogap"></div>
		<div className="keskitettymob">{window.VIDEOTEKSTIT.viidesosioekar}</div>
		<div key="gapihmomij" className="paragap"></div>
		<div className="keskitettymob">{window.VIDEOTEKSTIT.viidesosiotokar}</div>

		<div key="videoosiotokaf" className="keskitettymob" style={{backgroundSize: "100% 100%", backgroundImage: "url(\"lenkkaritausta.svg\")", backgroundRepeat: "no-repeat"}}>
			<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
				<div className="lenkkarimob">
					<img height={ihs(0.25)} src={window.VIDEOTEKSTIT.kuudesosiokuva} />
				</div>
			</div>
		</div>

		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div className="keskitettymob">{window.VIDEOTEKSTIT.kuudesosioekar}</div>
				<div key="gapihmomik" className="osiogap"></div>
				<div className="keskitettymob">{window.VIDEOTEKSTIT.kuudesosiotokar}</div>
			</div>
		</div>

		<div key="gapihmomil" className="osiogap"></div>

		<div key="gapihmomio" className="osiogap"></div>
		<div className="keskitettymob" style={{fontSize:"0.5em"}}>
				{window.VIDEOTEKSTIT.sivunalateksti}
		</div>


		<div className="seuraavasivumob">
			<div className="seuraavasivuotsikko" style={{transform: "scale(0.5)"}}>
				<Link to="../" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKaruselliMob} >
					<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>ALKUUN</span>
				</Link>
			</div>
			<div style={{transform: "scale(0.75)"}}>
				<Link to="../" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKaruselliMob} >
					<ArrowRight stroke="#000000"/>
				</Link>
			</div>
		</div>
		<div key="gapihmomidsiloppu" className="osiogap"></div>
		<div key="gapihmomidsiloppua" className="osiogap"></div>


	</div>);
}


function moveToKaruselliMob()
{
	window.SETKARUSELLI();
	window.drawKar();
}




export default VideoMob;
